import { isHash } from 'viem';
import * as z from 'zod';
import { AuctionConfigurationSchema } from '../auction-config/form/schema';
import { ReleaseInfoSchema } from '../release-info/form/schema';
import { SplitsSchema } from '../splits/form/schema';

// Global State
export const UploadToolSchema = z.object({
  id: z.string(),
  backendDraftId: z.string().nullable(),
  releaseId: z.string().nullable(),
  transaction: z
    .object({
      hash: z.string().refine(isHash, { message: 'Unexpected invalid transaction hash' }),
      chain: z.number(),
    })
    .nullable(),

  gelatoTaskId: z.string().nullish(),

  artistId: z.string(),
  isSaving: z.boolean(),
  isProcessing: z.boolean(),
  currentStep: z.number().nullable(),
  isLastStep: z.boolean(),
  isFirstStep: z.boolean(),
  lastCompletedStep: z.number(),
  // Steps State
  releaseInfo: ReleaseInfoSchema,
  splits: SplitsSchema,
  auctionConfig: AuctionConfigurationSchema,
});

export type UploadToolState = (typeof UploadToolSchema)['_input'];

// For persistance we just want to save FIELDS to local storage, not form state (errors, dirty, etc)
export const UploadToolPersistSchema = UploadToolSchema.extend({
  releaseInfo: ReleaseInfoSchema.pick({
    fields: true,
  }),
  splits: SplitsSchema.pick({
    fields: true,
  }),
  auctionConfig: AuctionConfigurationSchema.pick({
    fields: true,
    hasPresaleMint: true,
    hasGAEdition: true,
  }),
});

export type UploadToolPersistState = (typeof UploadToolPersistSchema)['_input'];

// Please bump version on every schema change
const version = '2.4';
export const key = `upload-tool-draft-${version}`;

export function UploadToolSchemaKey(id: string) {
  return `${key}-${id}`;
}
